<template lang="html">
  <section class="check-grid-icon">
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Icon Check</h4>
            <p class="card-description">Check missing grid icons by model</p>

            <b-row class="form-group">
              <label class="col-lg-2  pt-2">Model:</label>

              <div class="icon-check-inline col-lg-4">
                <div class="icon-check-model-row">
                  <div class="icon-check-model-select">
                    <b-select
                      v-model="selectedModel"
                      id="model"
                    >
                      <template v-for="models in modelGroupList">
                        <optgroup :label="models.label">
                          <option
                            v-for="(model, index) in models.items"
                            :key="index"
                            :value="model">
                            {{ model.label }}
                          </option>
                        </optgroup>
                      </template>
                    </b-select>
                  </div>

                  <button
                    v-if="selectedModel"
                    type="button"
                    class="btn btn-default btn-sm icon-check-clear-btn"
                    @click="clearModel"
                  >
                    ✕
                  </button>
                </div>       
              </div>
              <b-col class="col-lg-2 pt-2">Preview Data:</b-col>
              <b-col class="col-lg-4"><input type="checkbox" v-model="isPreview"/></b-col>
            </b-row>
            <button class="btn btn-primary icon-check-search-btn" @click="searchIcons">Search</button>
            <div class="row" v-if="searched">
              <div class="col-md-12">
                <b-alert variant="warning" :show="isPreview" class="mt-3">
                  <i class="mdi mdi-alert"></i> <b>Preview Data Attivo</b>
                </b-alert>
                <div class="icon-check-missing-filter">
                  <input
                    id="showOnlyMissing"
                    type="checkbox"
                    v-model="showOnlyMissing"
                  />
                  <label for="showOnlyMissing">Show only missing icons</label>
                </div>

                <div v-if="filteredIconRows && filteredIconRows.length">
                  <b-table
                      id="table"
                      striped
                      hover
                      responsive
                      :items="filteredIconRows"
                      :fields="fields"
                      class="ccb-table"
                    >
                    <template #cell(icon)="data">
                      <img
                        v-show="!data.item.iconMissing"
                        :src="data.item.url"
                        style="max-height:40px;"
                      />
                    </template>

                      <template v-slot:cell(missingIcon)="data" lang="html">
                        <div class="text-center">
                          <b-button
                            v-if="data.item.iconMissing"
                            class="col-lg-5 p-1 m-auto"
                            size="sm"
                            style="max-width: 2.875rem;"
                            variant="primary"
                            disabled
                          >
                            <i
                              class="mdi mdi-close-outline btn-outline-secondary"
                              style="display: block;"
                            ></i>
                          </b-button>

                          <b-button
                            v-else
                            class="col-lg-5 p-1 m-auto"
                            size="sm"
                            style="max-width: 2.875rem;"
                            variant="primary"
                            disabled
                          >
                          <i
                            class="mdi mdi-check-outline btn-outline-success"
                            style="display: block;"
                          ></i>
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div v-else>
                  <p><strong>No records found</strong></p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import { mapGetters } from "vuex";

export default {
  name: 'check_grid_icon',
  data() {
    return {
      modelGroupList: [],
      selectedModel: null,
      isPreview: false,
      searched: false,
      iconRows: [],
      showOnlyMissing: false,
      fields: [
        { key: 'opt', label: 'OPT', thClass: 'text-left', tdClass: 'text-left pl-3' },
        { key: 'icon', label: 'Icon', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'missingIcon', label: 'Icon present', thClass: 'text-center', tdClass: 'text-center' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ]),
    filteredIconRows() {
    if (this.showOnlyMissing) {
      return this.iconRows.filter(row => row.iconMissing);
    }
    return this.iconRows;
  }
  },
    
  methods: {
    checkImage(row) {
      const img = new Image();

      img.onload = () => {
        this.$set(row, 'iconMissing', !(img.naturalWidth > 1 && img.naturalHeight > 1));
      };

      img.onerror = () => {
        this.$set(row, 'iconMissing', true);
      };

      img.src = row.url;
    },
    clearModel() {
      this.selectedModel = null;
      this.iconRows = [];
      this.searched = false;
      this.showOnlyMissing = false;
    },
    searchIcons() {
      if (!this.selectedModel || !this.selectedModel.value) {
        this.$bvModal.msgBoxOk('Select a model', {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        });
        return;
      }

      this.iconRows = [];
      this.searched = false;

      this.axios
      .get('/ccb/auth/fe/confGridOptIconCheck/check', {
        params: { vet: this.selectedModel.value, isPreview: this.isPreview },
        ...this.authHeader
      })
      .then((response) => {
        this.iconRows = (response.data || []).map(item => {
          const row = {
            opt: item.opt,
            url: item.url,
            iconMissing: true
          };

          this.checkImage(row);
          return row;
        });

        this.searched = true;
      })
      .catch((error) => {
        console.log(error);
        this.iconRows = [];
        this.searched = true;
      });
    }
  },
  watch: {
    selectedModel(newVal) {
      this.iconRows = [];
      this.searched = false;
      this.showOnlyMissing = false;
    }
  },
  
  mounted() {
    var models = Object.values(
      this.getCurUser.countries.flatMap(country => country.modelGroupItemList).reduce((acc, group) => {
        if (acc[group.label]) {
          const existingValues = new Set(acc[group.label].items.map(i => i.value));
          acc[group.label].items.push(...group.items.filter(i => !existingValues.has(i.value)));
        } else {
          acc[group.label] = { ...group, items: [...group.items] };
        }
        return acc;
      }, {})
    );

    this.modelGroupList = models;

    if (this.modelGroupList.length && this.modelGroupList[0].items.length) {
      this.selectedModel = this.modelGroupList[0].items[0];
    }
  }
}
</script>

<style scoped lang="scss">
.check-grid-icon .icon-check-model-row {
  display: flex;
  align-items: center;
}

.check-grid-icon .icon-check-clear-btn {
  margin-left: 8px;
  padding: 4px 10px;
  line-height: 1;
}
.check-grid-icon .icon-check-missing-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
}

.check-grid-icon .icon-check-missing-filter label {
  margin: 0;
}
.check-grid-icon .ccb-table tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}

.check-grid-icon .ccb-table tbody tr:hover {
  background-color: #e6e6e6;
}

.check-grid-icon .ccb-table thead th {
  background-color: #f0f0f0;
  font-weight: 600;
}
.check-grid-icon .icon-check-inline {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.check-grid-icon .icon-check-search-btn {
  height: 34px;
}
</style>